// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ypL5j","for-members":"styles_for-members__syH8y","log-in-text":"styles_log-in-text__a4cw1","login-button":"styles_login-button__2gwbq"};